import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BrandMark } from "../components/Brand";
import { redeemMagicLink } from "../lib/attorneyAuth";
import { Loader2, AlertTriangle, Sparkles } from "lucide-react";

export default function MagicLinkRedeem() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;
    (async () => {
      try {
        const me = await redeemMagicLink(token);
        // Tiny welcome pause so the splash isn't jarring
        await new Promise((r) => setTimeout(r, 250));
        navigate(`/attorney/portal?welcome=${encodeURIComponent(me?.firm?.name || "")}`, { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail || e?.message || "This link can no longer be used.";
        setError(typeof detail === "string" ? detail : "This link can no longer be used.");
      }
    })();
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0A2540] to-[#001A3D] text-white flex flex-col items-center justify-center px-6" data-testid="magic-link-redeem">
      <div className="mb-8 opacity-90"><BrandMark inverted /></div>
      {!error ? (
        <div className="flex flex-col items-center text-center max-w-md">
          <div className="w-16 h-16 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-5 backdrop-blur-sm">
            <Loader2 className="w-7 h-7 text-[#7DD3FC] animate-spin" />
          </div>
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#7DD3FC] mb-3">
            <Sparkles className="w-3.5 h-3.5" /> Signing you in
          </div>
          <h1 className="font-display text-3xl font-semibold mb-2">Opening your firm portal…</h1>
          <p className="text-white/60 text-sm">No password needed. We're loading your firm's cases.</p>
        </div>
      ) : (
        <div className="flex flex-col items-center text-center max-w-md" data-testid="magic-link-error">
          <div className="w-16 h-16 rounded-2xl bg-[#7F1D1D]/30 border border-[#FCA5A5]/40 flex items-center justify-center mb-5">
            <AlertTriangle className="w-7 h-7 text-[#FCA5A5]" />
          </div>
          <h1 className="font-display text-3xl font-semibold mb-2">Link no longer active</h1>
          <p className="text-white/60 text-sm mb-6">{error}</p>
          <button onClick={() => navigate("/attorney-login")} className="px-4 h-10 rounded-md bg-[#0066FF] hover:bg-[#0052CC] text-white text-sm font-medium transition-colors" data-testid="magic-link-fallback-login">
            Sign in another way
          </button>
        </div>
      )}
    </div>
  );
}
